export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5506.bbf20b70.jpg";